var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zoom",class:_vm.size},[_c('a',{attrs:{"href":_vm.post.permalink,"target":"_blank"}},[_c('UIImage',_vm._b({class:_vm.size,attrs:{"src":_vm.post.media_url || _vm.post.thumbnail_url,"alt":_vm.post.caption}},'UIImage',(_vm.$props, _vm.$attrs),false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }